export default {
  ROUTE_CHANGED: 'ROUTE_CHANGED',
}
